import axios from "axios";


// API URL configuration based on environment
const getApiUrl = () => {
  
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  const env = process.env.NODE_ENV || 'development';
  

  switch (env) {
    case 'production':
      return 'https://api.var80.com'; // Production API URL
    case 'staging':
      return 'https://stage-api.var80.com'; // Staging API URL
    case 'development':
    default:
      return 'https://doshaquiz-backend-dfd2b7504775.herokuapp.com'; // Development API URL
  }
};

const apiUrl = getApiUrl();
export { apiUrl };

const axiosInstance = axios.create({
  // baseURL: 'http://localhost:9000'
  baseURL: apiUrl 
});
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      const { status, data } = error.response;
      
      if (status === 401) {
        console.error("Unauthorized access - redirecting to login");
        // Clear the expired token
        localStorage.removeItem("token");
        // Redirect to login page
        window.location.href = "/login";
      } else if (status === 403) {
        console.error("Forbidden access:", data?.error || "Permission denied");
        // Log the specific permission error for debugging
        if (data?.error) {
          console.error("Permission error details:", data.error);
        }
      }
    }
    return Promise.reject(error);
  }
);

export const getCompany = (companyId) =>
  axiosInstance.get(`/api/v1/companies/${companyId}`).then((res) => res.data);
export const updateCompany = (companyId, data) =>
  axiosInstance
    .patch(`/api/v1/companies/${companyId}`, data)
    .then((res) => res.data);
export const getCompanies = () =>
  axiosInstance.get('/api/v1/companies').then((res) => res.data);
export const getGeneratedContents = () =>
  axiosInstance.get('/uploads/generated_contents').then((res) => res.data);
export default axiosInstance;
